import { useEffect } from 'react';

export default ({ keyArr = null, onKeyDown = null, onKeyUp = null }) => {

	const handleKeyDown = e => {
		if ((!keyArr || keyArr.includes(e.key)) && onKeyDown)
			onKeyDown(e);
	};

	const handleKeyUp = e => {
		e.preventDefault();
		if ((!keyArr || keyArr.includes(e.key)) && onKeyUp)
			onKeyUp(e);
	};

	useEffect(() => {
		if (onKeyDown)
			window.addEventListener('keydown', handleKeyDown);

		if (onKeyUp)
			window.addEventListener('keyup', handleKeyUp);

		return () => {
			if (onKeyDown)
				window.removeEventListener('keydown', handleKeyDown);

			if (onKeyUp)
				window.removeEventListener('keyup', handleKeyUp);
		};
	}, []);
};
